// roles from: https://docs.microsoft.com/en-gb/azure/active-directory/users-groups-roles/directory-assign-admin-roles#role-template-ids
// note: we are only using the "MSGraph display name" not the "Azure portal display name"
export enum ActiveDirectoryRole {
  ApplicationAdministrator = '9B895D92-2CD3-44C7-9D02-A6AC2D5EA5C3',
  ApplicationDeveloper = 'CF1C38E5-3621-4004-A7CB-879624DCED7C',
  AuthenticationAdministrator = 'c4e39bd9-1100-46d3-8c65-fb160da0071f',
  AzureDevOpsAdministrator = 'e3973bdf-4987-49ae-837a-ba8e231c7286',
  AzureInformationProtectionAdministrator = '7495fdc4-34c4-4d15-a289-98788ce399fd',
  B2CUserflowAdministrator = '6e591065-9bad-43ed-90f3-e9424366d2f0',
  B2CUserFlowAttributeAdministrator = '0f971eea-41eb-4569-a71e-57bb8a3eff1e',
  B2CIEFKeysetAdministrator = 'aaf43236-0c0d-4d5f-883a-6955382ac081',
  B2CIEFPolicyAdministrator = '3edaf663-341e-4475-9f94-5c398ef6c070',
  BillingAdministrator = 'b0f54661-2d74-4c50-afa3-1ec803f12efe',
  CloudApplicationAdministrator = '158c047a-c907-4556-b7ef-446551a6b5f7',
  CloudDeviceAdministrator = '7698a772-787b-4ac8-901f-60d6b08affd2',
  CompanyAdministrator = '62e90394-69f5-4237-9190-012177145e10', // alternative name is Global Administrator
  ComplianceAdministrator = '17315797-102d-40b4-93e0-432062caca18',
  ComplianceDataAdministrator = 'e6d1a23a-da11-4be4-9570-befc86d067a7',
  ConditionalAccessAdministrator = 'b1be1c3e-b65d-4f19-8427-f6fa0d97feb9',
  CRMServiceAdministrator = '44367163-eba1-44c3-98af-f5787879f96a',
  CustomerLockBoxAccessApprover = '5c4f9dcd-47dc-4cf7-8c9a-9e4207cbfc91',
  DesktopAnalyticsAdministrator = '38a96431-2bdf-4b4c-8b6e-5d3d8abac1a4',
  DeviceAdministrators = '9f06204d-73c1-4d4c-880a-6edb90606fd8',
  DeviceJoin = '9c094953-4995-41c8-84c8-3ebb9b32c93f',
  DeviceManagers = '2b499bcd-da44-4968-8aec-78e1674fa64d',
  DeviceUsers = 'd405c6df-0af8-4e3b-95e4-4d06e542189e',
  DirectoryReaders = '88d8e3e3-8f55-4a1e-953a-9b9898b8876b',
  DirectorySynchronizationAccounts = 'd29b2b05-8046-44ba-8758-1e26182fcf32',
  DirectoryWriters = '9360feb5-f418-4baa-8175-e2a00bac4301',
  ExchangeServiceAdministrator = '29232cdf-9323-42fd-ade2-1d097af3e4de',
  ExternalIdentityProviderAdministrator = 'be2f45a1-457d-42af-a067-6ec1fa63bc45',
  GlobalReader = 'f2ef992c-3afb-46b9-b7cf-a126ee74c451',
  GroupAdministrator = 'fdd7a751-b60b-444a-984c-02652fe8fa1c',
  GuestInviter = '95e79109-95c0-4d8e-aee3-d01accf2d47b',
  HelpdeskAdministrator = '729827e3-9c14-49f7-bb1b-9608f156bbb8',
  IntuneServiceAdministrator = '3a2c62db-5318-420d-8d74-23affee5d9d5',
  KaizalaAdministrator = '74ef975b-6605-40af-a5d2-b9539d836353',
  LicenseAdministrator = '4d6ac14f-3453-41d0-bef9-a3e0c569773a',
  LyncServiceAdministrator = '75941009-915a-4869-abe7-691bff18279e',
  MessageCenterPrivacyReader = 'ac16e43d-7b2d-40e0-ac05-243ff356ab5b',
  MessageCenterReader = '790c1fb9-7f7d-4f88-86a1-ef1f95c05c1b',
  OfficeAppsAdministrator = '2b745bdf-0803-4d80-aa65-822c4493daac',
  PartnerTier1Support = '4ba39ca4-527c-499a-b93d-d9b492c50246',
  PartnerTier2Support = 'e00e864a-17c5-4a4b-9c06-f5b95a8d5bd8',
  PasswordAdministrator = '966707d0-3269-4727-9be2-8c3a10f19b9d',
  PowerBIServiceAdministrator = 'a9ea8996-122f-4c74-9520-8edcd192826c',
  PowerPlatformAdministrator = '11648597-926c-4cf3-9c36-bcebb0ba8dcc',
  PrivilegedAuthenticationAdministrator = '7be44c8a-adaf-4e2a-84d6-ab2649e08a13',
  PrivilegedRoleAdministrator = 'e8611ab8-c189-46e8-94e1-60213ab1f814',
  ReportsReader = '4a5d8f65-41da-4de4-8968-e035b65339cf',
  SearchAdministrator = '0964bb5e-9bdb-4d7b-ac29-58e794862a40',
  SearchEditor = '8835291a-918c-4fd7-a9ce-faa49f0cf7d9',
  SecurityAdministrator = '194ae4cb-b126-40b2-bd5b-6091b380977d',
  SecurityOperator = '5f2222b1-57c3-48ba-8ad5-d4759f1fde6f',
  SecurityReader = '5d6b6bb7-de71-4623-b4af-96380a352509',
  ServiceSupportAdministrator = 'f023fd81-a637-4b56-95fd-791ac0226033',
  SharePointServiceAdministrator = 'f28a1f50-f6e7-4571-818b-6a12f2af6b6c',
  TeamsCommunicationsAdministrator = 'baf37b3a-610e-45da-9e62-d9d1e5e8914b',
  TeamsCommunicationsSupportEngineer = 'f70938a0-fc10-4177-9e90-2178f8765737',
  TeamsCommunicationsSupportSpecialist = 'fcf91098-03e3-41a9-b5ba-6f0ec8188a12',
  TeamsServiceAdministrator = '69091246-20e8-4a56-aa4d-066075b2a7a8',
  User = 'a0b1b346-4d3e-4e8b-98f8-753987be4970',
  UserAccountAdministrator = 'fe930be7-5e62-47db-91af-98c3a49a38b1',
  WorkplaceDeviceJoin = 'c34f683f-4d5a-4403-affd-6615e00e3a7f'
}
